"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var App_vue_1 = __importDefault(require("./App.vue"));
var ant_design_vue_1 = __importDefault(require("ant-design-vue"));
require("ant-design-vue/dist/antd.css");
var router_1 = __importDefault(require("./router"));
// 百度统计代码
// @ts-ignore
var _hmt = _hmt || [];
(function () {
    var hm = document.createElement('script');
    hm.src = 'https://hm.baidu.com/hm.js?5cb4fa061ea3314a61a3e68acdefd747';
    var s = document.getElementsByTagName('script')[0];
    // @ts-ignore
    s.parentNode.insertBefore(hm, s);
})();
router_1.default.beforeEach(function (to, from, next) {
    if (_hmt) {
        if (to.path) {
            _hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }
    next();
});
vue_1.createApp(App_vue_1.default).use(router_1.default).use(ant_design_vue_1.default).mount('#app');
